import React from 'react'
import PropTypes from 'prop-types'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import Button from '@material-ui/core/Button'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import { makeStyles } from '@material-ui/core/styles'
import CloseIcon from '@material-ui/icons/Close'
import './SelectSourceForUnitMixDialog.scss'

const useStyles = makeStyles(theme => ({
  root: {
    padding: 'unset'
  },
  formControlRoot: {
    width: '342px',
    height: '48.7px',
    marginLeft: '8px'
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120
  },
  paperScrollPaper: {
    width: '395px',
    height: '385px',
    padding: '16px',
    borderRadius: '8px'
  },
  selectEmpty: {
    marginTop: theme.spacing(2)
  }
}))

function SelectSourceForUnitMixDialog(props) {
  const classes = useStyles()
  const [source, setSource] = React.useState('')
  const { SelectSourceDialogOpen, handleSourceDialog, unitMixSources, propertySearchData, isPropertyExists } = props
  const { omniviewproperty } = propertySearchData
  const handleCancel = () => {
    handleSourceDialog('cancel')
  }

  return (
    <Dialog
      open={SelectSourceDialogOpen}
      aria-labelledby="source-dialog-title"
      aria-describedby="source-dialog-description"
      data-testid="source-dialog"
      classes={{ paperScrollPaper: classes.paperScrollPaper }}
    >
      <div className="select-source-dialog">
        <span className="select-source-dialog-tittle">Select Source</span>
        <span><CloseIcon data-testid="button-save-comps-close" onClick={() => handleSourceDialog('cancel')} /></span>
      </div>

      {(!isPropertyExists && unitMixSources.length > 0 && omniviewproperty[0]?.propertyName) && (
        <div className="sourceContentNote">
          The Selected <span className="source-description">{omniviewproperty[0] && omniviewproperty[0].propertyName}</span> property have Unit Mix data from multiple sources. Please Select a source from below dropdown to add property to Comps Project.
        </div>
      )}

      <DialogContent classes={{ root: classes.root }}>
        <div className="save-source">Unit Mix Source</div>
        <div>
          <FormControl classes={{ root: classes.formControlRoot }} variant="outlined" className={classes.formControl}>
            {(!isPropertyExists && unitMixSources.length > 0) && (
              <div>
                <InputLabel id="source-select-outlined-label">
                  Source
                </InputLabel>
                <Select
                  label="source"
                  value={source}
                  id="source-select-outlined"
                  inputProps={{ 'data-testid': 'source-select-outlined' }}
                  onChange={event => setSource(event.target.value)}
                  labelWidth={10}
                >
                  {unitMixSources && unitMixSources.map((sourceObj, index) =>
                    <MenuItem key={index} value={sourceObj.key}>{sourceObj.value}</MenuItem>
                  )}
                </Select>
              </div>
            )}
            {unitMixSources.length === 0 && (
              <DialogContentText id="dialog-description">
                <span className="source-description">No Unit Mix data available for the selected {omniviewproperty[0] && omniviewproperty[0].propertyName} property.</span>
              </DialogContentText>
            )}
            {isPropertyExists && (
              <DialogContentText id="dialog-property-description">
                <span className="source-description">The selected {omniviewproperty[0] && omniviewproperty[0].propertyName} property already exists in the project.</span>
              </DialogContentText>
            )}
          </FormControl>
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          data-testid="button-source-comps-cancel"
          onClick={() => handleCancel('cancel')}
          size="large"
          id="button-source-comps-cancel"
        >
          Cancel
        </Button>
        {!isPropertyExists && (
          <Button
            data-testid="button-source-comps-add"
            onClick={() => handleSourceDialog('add', source)}
            size="large"
            id="button-source-comps-add"
            disabled={(unitMixSources.length === 0 ? false : !source)}
          >
            Add property
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}

SelectSourceForUnitMixDialog.propTypes = {
  SelectSourceDialogOpen: PropTypes.bool,
  handleSourceDialog: PropTypes.func,
  propertySearchData: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  unitMixSources: PropTypes.array,
  isPropertyExists: PropTypes.bool
}

export default SelectSourceForUnitMixDialog
